<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <c-search-form
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="missionId"
            :search-url="searchUrl"
            form-type="intable"
            custom-create-new
            custom-edit-item
            ref="tableData"
            :deleteMulti="false"
            orderBy="desc"
            :acceptView=false
            :accept-create="false"
            @openLink="openLink"
            @openLinkNewTap = "openLinkNewTap"
        >
        </c-search-form>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/mission/MissionCreate";
import {message} from "@/shared/message";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Thông tin phát âm ",
      searchUrl: null,
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "1%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'currentDate',
          text: 'Time',
          sortable: false,
          search: false,
          dateFormat: 'dd/MM/yyyy hh:mm',
          width: "7%",
          headerStyle: "text-align:center",
        },
        {
          value: 'accountid',
          text: 'Account Id',
          width: "4%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'profileid',
          text: 'Profile Id',
          width: "4%",
          sortable: false,
          headerStyle: "text-align:center"
        },
/*        {
          value: 'point',
          text: 'Point',
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },*/
        {
          value: 'text',
          text: 'Text',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'url',
          text: 'Url',
          items: [
            {
              event: "openLinkNewTap",
              color: "primary"
            },
          ],
          event: "openLinkNewTap",
          type: "mp3",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: "custom_action_list",
          text: "Open Url",
          width: "10%",
          headerStyle: "text-align:center;",
          items: [
            {
              icon: "play_arrow",
              event: "openLink",
              color: "primary"
            },
          ],
        },
      ]
    };
  },

  methods: {
    openLink(item) {
      var audio = new Audio(item.url);
      audio.play();
    },
    openLinkNewTap(item) {
      window.open(item.url, '_blank', 'noreferrer');
    },
  },

  created() {
    this.searchUrl = "/ispeckInfo/searchByPhone/" + this.$route.params.phone + "?sortField=accountid,classId&";
  }


};
</script>
